export const paths = []

export enum Permission {
	REPORTING_VIEW = 'RPT_VIEW',
	PM_VIEW = 'PM_VIEW'
}
export enum UserRole {}

export enum UrlParams {
	startDate = 'START_DATE',
	endDate = 'END_DATE',
	reportName = 'REPORT_NAME',
	supplierInvoiceNumber = 'SUPPLIER_INVOICE_NUMBER',
	status = 'STATUS',
	supplierLocationId = 'SUPPLIER_LOCATION_ID',
	documentTypeId = 'DOCUMENT_TYPE_ID',
	showOnlySupplierDocuments = 'SHOW_ONLY_SUPPLIER_DOCUMENTS'
}

export enum UrlParamsLabel {}
